<script>
import MetisMenu from "metismenujs/dist/metismenujs";

export default {
  mounted() {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu-public");
    var links = document.getElementsByClassName("side-nav-link-ref");
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        links[i].classList.add("active");
        var parent = links[i].parentElement;
        if (parent) parent.classList.add("mm-active");
        break;
      }
    }
  },
};
</script>

<template>
  <div id="sidebar-menu">
    <ul id="side-menu-public" class="metismenu list-unstyled mt-1">
      <li>
        <router-link tag="a" to="/telemedicina/consultas/publico" class="side-nav-link-ref">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
            <path d="M8 15h3v3h2v-3h3v-2h-3v-3h-2v3H8z"></path>
            <path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"></path>
          </svg>
          <span class="notranslate">Consultas</span>
        </router-link>
      </li>
      <li>
        <router-link tag="a" to="/telemedicina/exames/publico" class="side-nav-link-ref">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
            <path d="M8.648 14.711 11.997 18l3.35-3.289a2.129 2.129 0 0 0 0-3.069 2.225 2.225 0 0 0-3.126 0l-.224.219-.224-.219a2.224 2.224 0 0 0-3.125 0 2.129 2.129 0 0 0 0 3.069z"></path>
            <path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"></path>
          </svg>
          <span class="notranslate">Exames</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>
